import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';

const ProductSearch = lazy(() => import(/* webpackChunkName: "ProductSearch" */ './components/ProductSearch'));

const productSearchNodes = Array.from(document.querySelectorAll('.product-search'));

// Render component
if (productSearchNodes) {
    productSearchNodes.forEach((node) => {
        render(
            <Suspense fallback={<></>}>
                <ProductSearch
                    updateUrl={node.dataset.updateUrl}
                    redirectUrl={node.dataset.redirectUrl}
                    selectedBrand={node.dataset.selectedBrand}
                    selectedVehicleSource={node.dataset.vehicleSource}
                    stickerName={node.dataset.stickerName}
                    prefillSticker={node.dataset.prefillSticker}
                    advancedSearchUrl={node.dataset.advancedSearchUrl}
                />
            </Suspense>,
            node
        );
    });
}
